module.exports = __webpack_public_path__ + "static/index/img/baikal-114.9a90366f.jpg";